import { render } from "./psw.vue?vue&type=template&id=1486423e&scoped=true"
import script from "./psw.vue?vue&type=script&lang=js"
export * from "./psw.vue?vue&type=script&lang=js"

import "./psw.vue?vue&type=style&index=0&id=1486423e&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1486423e"]])

export default __exports__